export const INVITE_DATA_ATTR = 'data-browse-invite';

export const INVITE_KIND = {
  LOADING: 'loading',
  HIRE: 'hire',
  CHOOSER: 'chooser',
};

/**
 * @param {Element|null} inviteEl
 * @returns {{ kind: string|null, username: string|null, userId: string|null }|null}
 */
export function parseInviteTarget(inviteEl) {
  if (!inviteEl) {
    return null;
  }
  return {
    kind: inviteEl.getAttribute(INVITE_DATA_ATTR),
    username: inviteEl.getAttribute('data-username'),
    userId: inviteEl.getAttribute('data-user-id'),
  };
}

/**
 * @param {object} options
 * @param {() => Element|null} options.getRoot
 * @param {object|null} options.authUser
 * @param {{ push: (path: string) => void }} options.history
 * @param {{ current: boolean }} options.isMobileInviteRef
 * @param {function} options.setInviteDropdown
 * @param {function} options.setInviteChooserModal
 * @returns {(event: MouseEvent) => boolean} Click listener; returns true if invite handling consumed the event (stop further handlers in the same callback).
 */
export function createInviteToProjectHitHandler({
  getRoot,
  authUser,
  history,
  isMobileInviteRef,
  setInviteDropdown,
  setInviteChooserModal,
}) {
  return function handleInviteHitClick(event) {
    const root = getRoot();
    if (!root) {
      return false;
    }
    const inviteEl = event.target.closest(`[${INVITE_DATA_ATTR}]`);
    if (!inviteEl || !root.contains(inviteEl)) {
      return false;
    }
    const parsed = parseInviteTarget(inviteEl);
    if (!parsed || !parsed.kind || parsed.kind === INVITE_KIND.LOADING) {
      return true;
    }

    event.preventDefault();
    event.stopPropagation();

    if (!authUser) {
      window.location.href = '/signin';
      return true;
    }

    const { kind, username, userId } = parsed;

    if (kind === INVITE_KIND.HIRE) {
      if (username) {
        history.push(`/${username}/hire`);
      }
      return true;
    }

    if (kind === INVITE_KIND.CHOOSER) {
      if (username && userId) {
        if (isMobileInviteRef.current) {
          setInviteDropdown(null);
          setInviteChooserModal({ username, userId });
        } else {
          setInviteChooserModal(null);
          const rect = inviteEl.getBoundingClientRect();
          setInviteDropdown({
            username,
            userId,
            rect: {
              top: rect.top,
              left: rect.left,
              width: rect.width,
              height: rect.height,
            },
          });
        }
      }
      return true;
    }

    return true;
  };
}
